module.exports = __webpack_public_path__ + "9d0e3d0f2cb62a31a1ddc2dae041288f.png";